<template>
    <div class="row">
        <div class="col-md-12">
            <section class="panel">
                <header class="panel-heading">
                    <h2 class="panel-title">{{pageTitle}}</h2>
                </header>
                <div class="panel-body container-fluid">
                    <div class="form-group">
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">姓&emsp;&emsp;名：</label>
                                {{stuBase.name}}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">學&emsp;&emsp;制：</label>
                                {{stuBase.deptSsymStr}}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">性&emsp;&emsp;別：</label>
                                {{stuBase.sexStr}}
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">學&emsp;&emsp;號：</label>
                                {{stuBase.account}}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">科系班級：</label>
                                {{stuBase.deptCodeStr}}-{{stuBase.drade}}年{{stuBase.dradeClass}}班
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">身分證字號：</label>
                                {{stuBase.idno}}
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5 column-required">聯絡電話：</label>
                                <span v-if="isMage()" class="col-xs-9 col-md-7">{{stuBase.tel}}</span>
                                <label v-else class="col-xs-9 col-md-7">
                                    <input type="text" name="tel" v-model="stuBase.tel" placeholder="聯絡電話" v-validate="'required|tel'" class="form-control" />
                                    <span class="text-danger" v-show="errors.has('tel')">{{ errors.first('tel') }}</span>
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5 column-required">行動電話：</label>
                                <span v-if="isMage()" class="col-xs-9 col-md-7">{{stuBase.phone}}</span>
                                <label v-else class="col-xs-9 col-md-7">
                                    <input type="text" name="phone" v-model="stuBase.phone" v-validate="'required|phone'" placeholder="行動電話" class="form-control" />
                                    <span class="text-danger" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">常用信箱：</label>
                                <span v-if="isMage()" class="col-xs-9 col-md-7">{{stuBase.extMail}}</span>
                                <label v-else class="col-xs-9 col-md-7">
                                    <input type="email" name="extMail" v-model="stuBase.extMail" placeholder="常用信箱" class="form-control" />
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">學校信箱：</label>
                                <label class="col-xs-9 col-md-7">
                                    {{ stuBase.schMail }}
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">家長姓名：</label>
                                {{ stuBase.parentName }}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">關　　係：</label>
                                {{ stuBase.kinship }}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">家長電話：</label>
                                {{ stuBase.parentPhone }}
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">戶籍地址：</label>
                                <div class="col-xs-8 col-md-10">
                                    {{ stuBase.resiFullAddress }}
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">通訊地址：</label>
                                <div class="col-xs-8 col-md-10">
                                    {{ stuBase.mailFullAddress }}
                                </div>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">寢室名稱(房號)：</label>
                                <div class="col-xs-8 col-md-10">
                                    {{dormitoryApply.bedFloor}}-{{dormitoryApply.bedRoom}}-{{dormitoryApply.bed}}-{{dormitoryApply.bedCategory}}
                                </div>
                            </div>
                        </div>

                        <div v-if="storeData.leaveType ==='L'">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2 column-required">離宿日期：</label>
                                    <div class="col-xs-8 col-md-10" v-if="isMage()">{{customFormatter(dormitoryLeave.leaveDate)}}</div>
                                    <div class="col-xs-8 col-md-10" v-else>
                                        <datepicker name="leaveDate" v-validate="'required'" :format="customFormatter" :language="zh"
                                                    :disabled-dates="state.disabledDates" v-model="dormitoryLeave.leaveDate" input-class="form-control"
                                                    placeholder="離宿日期" :style="{width:'auto', display:'inline-block'}" :calendarClass="'mobile_size'"
                                                    @input="selectLeaveDate"/>
                                        <span class="text-danger" v-show="errors.has('leaveDate')">{{ errors.first('leaveDate') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2 column-required">離宿時段：</label>
                                    <div class="col-xs-8 col-md-10" v-if="isMage()">{{dormitoryLeave.leavePeriod}}</div>
                                    <div class="col-xs-8 col-md-10" v-else>
                                        <select name="leavePeriod" v-validate="'required'" v-model="dormitoryLeave.leavePeriod" :disabled="!dormitoryLeave.leaveDate">
                                            <option :value="null">--請選擇--</option>
                                            <option v-for="(item, index) in leavePeriodList" :value="item" :key="index">
                                              {{ item }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('leavePeriod')">{{ errors.first('leavePeriod') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="text-danger">備註說明</label>
                                </div>
                                <div class="col-md-12" style="height:6cm;" v-html="content">
                                </div>
                            </div>
                        </div>
                        <div v-if="storeData.leaveType === 'C'">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2">存摺局號(本人)：</label>
                                    <div class="col-xs-8 col-md-10">
                                        {{stuBase.bandNo}}
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2">存摺帳號(本人)：</label>
                                    <div class="col-xs-8 col-md-10">
                                        {{stuBase.bankAccount}}
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2">是否辦理就學貸款：</label>
                                    <div class="col-xs-8 col-md-10">
                                        {{dormitoryApply.isStuLoanStr}}
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-3 col-md-2 column-required">申請退宿原因：</label>
                                    <div class="col-xs-9 col-md-10">
                                        <div class="col-xs-4 col-md-2" v-if="isMage()">
                                            {{dormitoryLeave.leaveReasonStr}}
                                        </div>
                                        <div class="col-xs-4 col-md-2" v-else>
                                            <select id="leaveReason" name="leaveReason" v-validate="'required'" class="form-control" v-model="dormitoryLeave.leaveReason">
                                                <option value="">請選擇</option>
                                                <option v-for="(item, index) in leaveReasonList" :key="index" :value="item.commCode">{{item.commValue}}</option>
                                            </select>
                                            <span class="text-danger" v-show="errors.has('leaveReason')">{{ errors.first('leaveReason') }}</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label>說明:</label>
                                </div>
                                <div class="col-md-12">
                                    <p v-if="isMage()">{{dormitoryLeave.leaveRemark}}</p>
                                    <textarea class="form-control" rows="5" name="leaveRemark" v-model="dormitoryLeave.leaveRemark" v-else maxlength="100"></textarea>
                                </div>
                            </div>

                            <div class="row form-group" v-if="dormitoryLeave.leaveReason == '2' || dormitoryLeave.leaveReason == '3' ">
                                <div class="col-md-12">
                                    <label class="column-required">退宿後居住地址：(依申請退宿原因，地址選項會有所不同)</label>
                                </div>
                                <div class="col-md-12" v-if="isMage()">
                                    <p>{{dormitoryLeave.liveCityStr}}{{dormitoryLeave.liveAreaStr}}{{dormitoryLeave.liveRoadStr}}{{dormitoryLeave.liveAddr}}</p>
                                </div>
                                <div class="col-md-12" v-else>
                                    <div class="col-xs-6 col-md-2 form-group">
                                        <select v-model="dormitoryLeave.liveCityId" name="liveCityId" class="selbox form-control" v-validate="'required'" @change="getLeaveArea">
                                            <option value="">請選擇</option>
                                            <option v-for="(item,key) in cityList" :key="key" :value="item.cityId">{{ item.cityName }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('liveCityId')">{{ errors.first('liveCityId') }}</span>
                                    </div>
                                    <div class="col-xs-6 col-md-2 form-group">
                                        <select v-model="dormitoryLeave.liveAreaId" name="liveAreaId" class="selbox form-control" v-validate="'required'" @change="getLeaveRoad">
                                            <option value="">請選擇</option>
                                            <option v-for="(item,key) in areaList" :key="key" :value="item.areaId">{{ item.areaName }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('liveAreaId')">{{ errors.first('liveAreaId') }}</span>
                                    </div>
                                    <div class="col-xs-12 col-md-2 form-group" v-if="dormitoryLeave.leaveReason == '3'">
                                        <select v-model="dormitoryLeave.liveRoadId" name="liveRoadId" class="selbox form-control" v-validate="'required'">
                                            <option value="">請選擇</option>
                                            <option v-for="(item,key) in roadList" :key="key" :value="item.roadId">{{ item.roadName }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('liveRoadId')">{{ errors.first('liveRoadId') }}</span>
                                    </div>
                                    <div class="col-xs-12 col-md-3 form-group" v-if="dormitoryLeave.leaveReason == '3'">
                                        <input type="text" id="liveAddr" name="liveAddr" v-validate="'required'" class="form-control" v-model="dormitoryLeave.liveAddr" placeholder="地址" maxlength="100" />
                                        <span class="text-danger" v-show="errors.has('liveAddr')">{{ errors.first('liveAddr') }}</span>
                                    </div>
                                </div>

                            </div>
                            <div class="row form-group" v-if="!isMage()">
                                <div class="col-md-12 form-group">
                                    <label>學生申請自 {{this.dormitoryApply.smtrStr}} 起，申請退宿，並保證遵守下列事項：</label>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label>
                                        <span :style="{color:'#FF0000'}">本人同意下列事項: </span>(同意請打勾) <input type="checkbox" v-validate="'required'" name="isCheckBoxOk" v-model="isCheckBoxOk" />
                                        <span class="text-danger" v-show="errors.has('isCheckBoxOk')">{{ errors.first('isCheckBoxOk') }}</span>
                                    </label>
                                    <p style="margin: 0 !important;padding: 0 !important;">1. 該學年度內不得再申請住校。</p>
                                    <p style="margin: 0 !important;padding: 0 !important;">2. 不得使用或占用宿舍寢室或床位。</p>
                                    <p style="margin: 0 !important;padding: 0 !important;">3. 個人物品於申請後，於三日內立即搬離，否則視同廢棄物處理。</p>
                                    <p style="margin: 0 !important;padding: 0 !important;">4. 入住學生都須遵守宿舍相關規範，如不遵守將視情況予以退宿。</p>
                                </div>
                                <div class="col-md-12 form-group">
                                    <p style="margin: 0 !important;padding: 0 !important;" class="text-danger">退費金額 : {{leaveAmt}}元</p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>退費標準：依據學生宿住宿輔導及管理辦法第五條第四款第二項。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（一）已完成登記繳費，尚未進住宿舍者，全額退費。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（二）開學後未逾一個月，退還二分之一費用。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（三）開學後逾一個月未逾兩個月，退還三分之一費用。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（四）開學後逾二個月退宿，不予退費。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（五) 因個人因素遭到學校退宿者，一律不予退費。</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group" v-if="!isMage()">
                        <div class="col-md-12">
                            <div class="col-md-offset-4 col-md-2 col-xs-offset-3 col-xs-3">
                                <button @click="handleCancel" class="btn s_btn_g btn-block">取消</button>
                            </div>
                            <div class="col-md-2 col-xs-3">
                                <button @click="handleSave" class="btn btn-primary btn-block">送出申請</button>
                            </div>
                        </div>
                    </div>

                    <div class="row form-group" v-if="isMage()">
                        <div class="col-md-12 form-group">
                            <label class="col-xs-3 col-md-2 column-required form-group">{{leaveBelongTitle}}</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 " v-for="(item, index) in belongList" :key="index">
                                    <label :for="'belongList_'+index">
                                        <input :id="'belongList_'+index" name="leaveBelong" type="checkbox" :value="item.commCode" v-model="leaveBelong" v-validate="'required'">{{item.commValue}}
                                    </label>
                                </div>
                                <span class="text-danger" v-show="errors.has('leaveBelong')">{{ errors.first('leaveBelong') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label class="col-xs-3 col-md-2 column-required form-group">環境清潔<br />(寢室及公共區域)：</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 " v-for="(item, index) in milieuList" :key="index">
                                    <label :for="'milieuList_'+index">
                                        <input :id="'milieuList_'+index" name="leaveMilieu" type="checkbox" :value="item.commCode" v-model="leaveMilieu" v-validate="'required'">{{item.commValue}}
                                    </label>
                                </div>
                                <span class="text-danger" v-show="errors.has('leaveMilieu')">{{ errors.first('leaveMilieu') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label class="col-xs-3 col-md-2 column-required form-group">Key：</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 " v-for="(item, index) in keyList" :key="index">
                                    <label :for="'keyList_'+index">
                                        <input :id="'keyList_'+index" name="leaveKey" type="checkbox" :value="item.commCode" v-model="leaveKey" v-validate="'required'">{{item.commValue}}
                                    </label>
                                </div>
                                <span class="text-danger" v-show="errors.has('leaveKey')">{{ errors.first('leaveKey') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 form-group" v-if="isAdmin('stay')">
                            <label class="col-xs-3 col-md-2 column-required form-group">審核狀態：</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_A">
                                        <input id="leaveStatus_A" name="leaveStatus" type="radio" value="A" v-model="dormitoryLeave.leaveStatus" />待審核
                                    </label>
                                </div>
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_Y">
                                        <input id="leaveStatus_Y" name="leaveStatus" type="radio" value="Y" v-model="dormitoryLeave.leaveStatus" />審核通過
                                    </label>
                                </div>
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_N">
                                        <input id="leaveStatus_N" name="leaveStatus" type="radio" value="N" v-model="dormitoryLeave.leaveStatus" />審核不通過
                                    </label>
                                </div>
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_R">
                                        <input id="leaveStatus_R" name="leaveStatus" type="radio" value="R" v-model="dormitoryLeave.leaveStatus" />退回
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <div class="col-md-offset-4 col-md-2 col-xs-offset-3 col-xs-3">
                                <button @click="handleCancel" class="btn s_btn_g btn-block">取消</button>
                            </div>
                            <div class="col-md-2 col-xs-3">
                                <button @click="acceptSave" class="btn btn-primary btn-block">點交完成</button>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    </div>
</template>

<script>
export default {
    props: ["leaveType", "account", "dormitoryType", "idno", "smtr"],
    data() {
        return {
            leaveReasonList: [],
            belongList: [],
            keyList: [],
            milieuList: [],
            cityList: [],
            areaList: [],
            roadList: [],
            lastDate: "",
            stuBase: {},
            dormitoryApply: {},
            dormitoryLeave: {
                applyId: "",
                leaveType: "",
                leaveAmt: null,
                leaveReason: "",
                liveCityId: "",
                liveAreaId: "",
                liveRoadId: "",
                leaveBelong: "",
                leaveMilieu: "",
                leaveKey: "",
            },
            isCheckBoxOk: false,
            leaveAmt: 0,
            leaveBelong: [],
            leaveMilieu: [],
            leaveKey: [],
            leaveDate: null,
            pageTitle: "",
            storeData: {},
            state: {
                disabledDates: {
                  customPredictor: this.leaveDisableDate,
                },
            },
            leaveDatePeriodList: [],
            leavePeriodList: [],
            content: "",
        };
    },
    async mounted() {
        if (this.getStore(this.$route.name) != null) {
            this.storeData = JSON.parse(this.getStore(this.$route.name));
        }
        if (this.storeData.leaveType == "C") {
            this.pageTitle = "退宿申請表";
        } else if (this.storeData.leaveType == "L") {
            this.pageTitle = "離宿申請表";
            // 取得可離宿日期時段
            const api = "/api/room/getDormitoryLeaveDatePeriod";
            const query = new URLSearchParams({
              startDate: this.customFormatter(new Date()),
              endDate: ''
            }).toString();
            this.$axios.get(api + '?' + query).then(resp =>{
              this.leaveDatePeriodList = resp.data.data.rows;
            });
        }
        let _this = this;
        const api = "/api/Room/leaveInit";
        this.$axios.post(api).then((resp) => {
            _this.cityList = resp.data.data.cityList;
            _this.keyList = resp.data.data.keyList;
            _this.milieuList = resp.data.data.milieuList;
            _this.belongList = resp.data.data.belongList;
            _this.leaveReasonList = resp.data.data.leaveReasonList;
            _this.lastDate = resp.data.data.lastDate;
        });

      this.$axios.get(`/api/common/treaty?type=stay-leave`).then(resp => {
        this.content = this.htmlDecode(resp.data.content);
      });

        await this.init();
    },
    methods: {
        async init() {
            const initParam = {
                account: this.storeData.account,
                idno: this.storeData.idno,
                id: this.storeData.id,
            };
            const api = "/api/Room/roomInfo";
            let resp = await this.$axios.post(api, initParam);
            const _this = this;
            if (resp.data.status === "success") {
                if ("stuBase" in resp.data.data) {
                    this.stuBase = resp.data.data.stuBase;
                }
                if ("dormitoryApply" in resp.data.data) {
                    this.dormitoryApply = resp.data.data.dormitoryApply;
                    let intoRoomDate = new Date(this.dormitoryApply.intoRoomDate);

                    if (this.storeData.leaveType == "C") {
                        //退宿時退費金額計算
                        if (intoRoomDate > new Date() || !this.dormitoryApply.intoRoomDate) {
                            this.leaveAmt = this.dormitoryApply.roomAmt + this.dormitoryApply.ensureAmt;
                        } else {
                            const oneMonth = new Date(this.dormitoryApply.intoRoomDate);
                            oneMonth.setMonth(oneMonth.getMonth() + 1);
                            const twoMonth = new Date(this.dormitoryApply.intoRoomDate);
                            twoMonth.setMonth(twoMonth.getMonth() + 2);
                            if (new Date() >= intoRoomDate && new Date() < oneMonth) {
                                this.leaveAmt = Math.round(this.dormitoryApply.roomAmt / 2) + this.dormitoryApply.ensureAmt;
                            } else if (new Date() >= oneMonth && new Date() < twoMonth) {
                                this.leaveAmt = Math.round(this.dormitoryApply.roomAmt / 3) + this.dormitoryApply.ensureAmt;
                            } else if (new Date() >= twoMonth) {
                                this.leaveAmt = 0 + this.dormitoryApply.ensureAmt;
                            }
                        }
                    } else {
                        //離宿時退費金額計算
                        this.leaveAmt = 0 + this.dormitoryApply.ensureAmt;
                    }
                    if (this.dormitoryApply.tbDormitoryLeave) {
                        this.dormitoryLeave = this.dormitoryApply.tbDormitoryLeave;
                        if (!this.isMage() && this.dormitoryLeave.leaveStatus != "R") {
                            bootbox.alert("請勿重複申請", function () {
                                _this.$router.go(-1);
                            });
                        }
                        if (this.dormitoryLeave.liveCityId) {
                            this.getLeaveArea();
                        } else {
                            this.dormitoryLeave.liveCityId = "";
                        }
                        if (this.dormitoryLeave.liveAreaId) {
                            this.getLeaveRoad();
                        } else {
                            this.dormitoryLeave.liveAreaId = "";
                        }
                        if (!this.dormitoryLeave.liveRoadId) {
                            this.dormitoryLeave.liveRoadId = "";
                        }
                        if (!this.dormitoryLeave.leaveReason) {
                            this.dormitoryLeave.leaveReason = "";
                        }
                        if (this.dormitoryLeave.leaveBelong) {
                            let leaveBelongJson = JSON.parse(this.dormitoryLeave.leaveBelong);
                            for (let k in leaveBelongJson) {
                                if (leaveBelongJson[k] === "Y") {
                                    this.leaveBelong.push(k);
                                }
                            }
                        }
                        if (this.dormitoryLeave.leaveMilieu) {
                            let leaveMilieuJson = JSON.parse(this.dormitoryLeave.leaveMilieu);
                            for (let k in leaveMilieuJson) {
                                if (leaveMilieuJson[k] === "Y") {
                                    this.leaveMilieu.push(k);
                                }
                            }
                        }
                        if (this.dormitoryLeave.leaveKey) {
                            let leaveKeyJson = JSON.parse(this.dormitoryLeave.leaveKey);
                            for (let k in leaveKeyJson) {
                                if (leaveKeyJson[k] === "Y") {
                                    this.leaveKey.push(k);
                                }
                            }
                        }
                    }
                }
                if (this.dormitoryLeave.leaveDate) {
                  this.selectLeaveDate();
                }
            } else {
                bootbox.alert(resp.data.msg, function () {
                    _this.$router.go(-1);
                });
            }
        },
        handleCancel() {
            this.$router.go(-1);
        },
        handleSave() {
            const _this = this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    const api = "/api/Room/saveApplyRoomLeave";
                    this.dormitoryLeave.applyId = this.dormitoryApply.id;
                    this.dormitoryLeave.leaveType = this.storeData.leaveType;
                    this.dormitoryLeave.leaveAmt = this.leaveAmt;
                    let requestDormitoryLeave = {};
                    for (let k in this.dormitoryLeave) {
                        if (this.dormitoryLeave[k]) {
                            requestDormitoryLeave[k] = this.dormitoryLeave[k];
                        }
                    }
                    this.$axios.post(api, JSON.stringify(requestDormitoryLeave)).then((resp) => {
                        let status = resp.data.status;
                        bootbox.alert(resp.data.msg, function () {
                            if (status === "success") {
                                _this.$router.go(-1);
                            }
                        });
                    });
                } else {
                    bootbox.alert("請確認必填欄位是否有填寫");
                }
            });
        },
        acceptSave() {
            const _this = this;
            this.$validator.validateAll().then((result) => {
                if (!result && (this.dormitoryLeave == "Y" || this.dormitoryLeave == "N")) {
                    bootbox.alert("請確認必填欄位是否有填寫");
                    return false;
                }
                let leaveBelong = {};
                for (let i in this.belongList) {
                    let tmp = this.leaveBelong.filter((x) => {
                        return x == this.belongList[i].commCode;
                    });
                    if (tmp.length > 0) {
                        leaveBelong[this.belongList[i].commCode] = "Y";
                    } else {
                        leaveBelong[this.belongList[i].commCode] = "N";
                    }
                }
                let leaveMilieu = {};
                for (let i in this.milieuList) {
                    let tmp = this.leaveMilieu.filter((x) => {
                        return x == this.milieuList[i].commCode;
                    });
                    if (tmp.length > 0) {
                        leaveMilieu[this.milieuList[i].commCode] = "Y";
                    } else {
                        leaveMilieu[this.milieuList[i].commCode] = "N";
                    }
                }
                let leaveKey = {};
                for (let i in this.keyList) {
                    let tmp = this.leaveKey.filter((x) => {
                        return x == this.keyList[i].commCode;
                    });
                    if (tmp.length > 0) {
                        leaveKey[this.keyList[i].commCode] = "Y";
                    } else {
                        leaveKey[this.keyList[i].commCode] = "N";
                    }
                }
                this.dormitoryLeave.leaveBelong = JSON.stringify(leaveBelong);
                this.dormitoryLeave.leaveMilieu = JSON.stringify(leaveMilieu);
                this.dormitoryLeave.leaveKey = JSON.stringify(leaveKey);
                if (this.leaveBelong.length > 0 && this.leaveMilieu.length > 0 && this.leaveKey.length > 0) {
                    this.dormitoryLeave.leaveAccept = "Y";
                } else {
                    this.dormitoryLeave.leaveAccept = "N";
                }
                let requestDormitoryLeave = {};
                for (let k in this.dormitoryLeave) {
                    if (this.dormitoryLeave[k]) {
                        if (k == "leaveDate") {
                            requestDormitoryLeave[k] = this.customFormatter(this.dormitoryLeave[k]);
                        } else {
                            requestDormitoryLeave[k] = this.dormitoryLeave[k];
                        }
                    }
                }
                const api = "/api/Room/saveApplyRoomLeaveAccept";
                this.$axios.post(api, requestDormitoryLeave).then((resp) => {
                    let status = resp.data.status;
                    bootbox.alert(resp.data.msg, function () {
                        if (status == "success") {
                            _this.$router.go(-1);
                        }
                    });
                });
            });
        },
        async getLeaveArea() {
            if (this.baseDataIsNotEmpty) {
                this.dormitoryLeave.liveAreaId = "";
                this.dormitoryLeave.liveRoadId = "";
                this.areaList = [];
                this.roadList = [];
                const api = "/api/Common/getArea/" + this.dormitoryLeave.liveCityId;
                let resp = await this.$axios.post(api);
                if (resp.data.status == "success") {
                    this.areaList = resp.data.data.areaList;
                }
            }
        },
        async getLeaveRoad() {
            if (this.baseDataIsNotEmpty) {
                this.dormitoryLeave.liveRoadId = "";
                this.roadList = [];
                const api = "/api/Common/getRoad/" + this.dormitoryLeave.liveAreaId;
                let resp = await this.$axios.post(api);
                if (resp.data.status == "success") {
                    this.roadList = resp.data.data.roadList;
                }
            }
        },
        isMage() {
            let result = false;
            if (this.isAdmin("stay")) {
                result = true;
            } else if (this.sessionData.accountType == "STU") {
                if (this.sessionData.isRoomMage == "Y" && this.storeData.account != this.sessionData.account) {
                    result = true;
                }
            }
            return result;
        },
        lastDateFormat(leaveDate) {
            const dayList = ["日", "一", "二", "三", "四", "五", "六"];
            let rocDate = leaveDate.getFullYear() - 1911 + "年" + (leaveDate.getMonth() + 1) + "月" + leaveDate.getDate() + "日(星期" + dayList[leaveDate.getDay()] + ")";
            return rocDate;
        },
        leaveDisableDate(date) {
          let d = this.customFormatter(date);
          return !this.leaveDatePeriodList.find(dp => this.customFormatter(dp.date) == d);
        },
        selectLeaveDate() {
          this.leavePeriodList = this.leaveDatePeriodList.find(dp => this.customFormatter(dp.date) == this.customFormatter(this.dormitoryLeave.leaveDate)).periods;
        }
    },
    computed: {
        leaveBelongTitle() {
            let str = "";
            if (this.storeData.leaveType === "L") {
                str = "離宿財產清單";
            } else if (this.storeData.leaveType === "C") {
                str = "退宿財產清單";
            }
            return str;
        },
        baseDataIsNotEmpty() {
            return !this.jsonIsEmpty(this.dormitoryLeave);
        },
    },
    watch: {},
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
        next();
    },
};
</script>

<style>
.mobile_size {
    width: auto;
}
</style>
